"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportData = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const form_1 = require("../../../composite/form/form");
const form_date_time_field_1 = require("../../../composite/form/fields/form-date-time-field");
const form_table_field_1 = require("../../../composite/form/fields/form-table-field");
const reporting_types_1 = require("../reporting-types");
const table_field_cells_1 = require("../../../components/table-field/table-field-cells");
const list_source_hook_1 = require("../../../utils/list-source-hook");
function ReportData({ report, formRef, }) {
    var _a;
    const intl = react_intl_1.useIntl();
    const columns = ((_a = report === null || report === void 0 ? void 0 : report.columns) !== null && _a !== void 0 ? _a : []).map((c) => 
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useTableFieldColumn(c));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoizedColumns = react_1.useMemo(() => columns, [report]);
    if (report === null) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_1.Form, { ref: formRef, initialValues: {}, onSubmit: lodash_1.noop, editing: false },
            report.created !== undefined && (react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { label: intl.formatMessage({
                    id: 'EAS_REPORTING_DATA_FIELD_CREATED',
                    defaultMessage: 'Generováno',
                }), name: "created" })),
            react_1.default.createElement(form_table_field_1.FormTableField, { name: "data", labelOptions: { hide: true }, showToolbar: false, showDetailBtnCond: lodash_1.stubFalse, showRadioCond: lodash_1.stubFalse, columns: memoizedColumns }))));
}
exports.ReportData = ReportData;
function useTableFieldColumn(column) {
    const SelectCellComponent = useSelectCellComponentFactory(column);
    let CellComponent;
    switch (column.type) {
        default:
        case reporting_types_1.ReportColumnType.TEXT:
            CellComponent = table_field_cells_1.TableFieldCells.TextCell;
            break;
        case reporting_types_1.ReportColumnType.NUMBER:
            CellComponent = table_field_cells_1.TableFieldCells.NumberCell;
            break;
        case reporting_types_1.ReportColumnType.BOOLEAN:
            CellComponent = table_field_cells_1.TableFieldCells.BooleanCell;
            break;
        case reporting_types_1.ReportColumnType.DATE:
            CellComponent = table_field_cells_1.TableFieldCells.DateCell;
            break;
        case reporting_types_1.ReportColumnType.DATETIME:
            CellComponent = table_field_cells_1.TableFieldCells.DateTimeCell;
            break;
        case reporting_types_1.ReportColumnType.TIME:
            CellComponent = table_field_cells_1.TableFieldCells.TimeCell;
            break;
        case reporting_types_1.ReportColumnType.SELECT:
            CellComponent = SelectCellComponent;
            break;
    }
    return {
        name: column.name,
        datakey: column.datakey,
        width: column.width,
        minWidth: column.minWidth,
        CellComponent,
    };
}
function useSelectCellComponentFactory(column) {
    var _a;
    const source = list_source_hook_1.useStaticListSource((_a = column.selectItems) !== null && _a !== void 0 ? _a : []);
    return table_field_cells_1.TableFieldCells.useSelectCellFactory(() => source);
}
//# sourceMappingURL=report-data.js.map